const SelectField = ({
    handleChange,
    value,
    name,
    options=[],
    isId,
    customClass,
    isDisabled
}) => {
  return (
    <select
      className={`vendor-add-select ${customClass} ${isDisabled ? "disabled-field" :""}`}
      name={name}
      onChange={(e) => handleChange(e)}
      value={value || ""}
      disabled={isDisabled}
    >
      <option value="">Select {name}</option>
      {options.map((item, index) => (
        <option key={index} value={isId ? item.id : item.value}>
          {isId ? item.name :item?.label}
        </option>
      ))}
    </select>
  );
};

export default SelectField;
